import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-y-4 relative p-4 font-montserrat min-h-0" }
const _hoisted_2 = { class: "overflow-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Search = _resolveComponent("Search")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Notification = _resolveComponent("Notification")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Dialog, {
      modelValue: _ctx.visible,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.visible = $event)),
      title: _ctx.$t('pickupV2.modalSttPickupList.title', { bkdCount: _ctx.bkdCount }),
      persistent: "",
      customBody: "p-0",
      customWidth: "w-3/5",
      showOverflow: true
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode(_component_Search, {
            onInput: _ctx.onSearch,
            onClear: () => _ctx.onSearch(''),
            value: _ctx.params.search,
            placeholder: _ctx.$t('pickupV2.modalSttPickupList.searchPlaceholder'),
            class: "w-300px"
          }, null, 8, ["onInput", "onClear", "value", "placeholder"]),
          _createVNode("div", _hoisted_2, [
            _createVNode(_component_TableV2, {
              columns: _ctx.columns,
              data: _ctx.listSttData.data,
              isEmpty: _ctx.isErrorList,
              iconEmpty: _ctx.isEmpty ? '' : 'ill_spot_search',
              emptyHeaderMessage: 
            _ctx.isEmpty
              ? _ctx.$t('pickupV2.modalSttPickupList.empty.title')
              : _ctx.$t('pickupV2.modalSttPickupList.notFound.title')
          ,
              emptyMessage: 
            _ctx.isEmpty
              ? _ctx.$t('pickupV2.modalSttPickupList.empty.message')
              : _ctx.$t('pickupV2.modalSttPickupList.notFound.message')
          ,
              loading: _ctx.isLoading,
              pagination: _ctx.pagination,
              "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pagination = $event)),
              onRequest: _ctx.onRequest,
              isSpaceTop: false,
              borderTop: false,
              isDetailAble: false,
              bgHeader: "bg-white",
              isBorderOnHeadBgWhite: "",
              isPinnedScrollBottom: "",
              pinnedSubstractHeight: "400px",
              paginationStyle: "v3",
              customClassPagination: "absolute left-0 right-0 bottom-0 px-4"
            }, null, 8, ["columns", "data", "isEmpty", "iconEmpty", "emptyHeaderMessage", "emptyMessage", "loading", "pagination", "onRequest"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_Notification, {
      modelValue: _ctx.notification,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.notification = $event)),
      isCustom: "",
      message: _ctx.copyStyles.message,
      customStyles: _ctx.copyStyles,
      isAutoDisplay: false,
      isAutoClose: "",
      timeout: 3,
      class: _ctx.copyStyles.width,
      showIconClose: false
    }, null, 8, ["modelValue", "message", "customStyles", "class"])
  ], 64))
}